import {Content} from './Content';

export function Home() {
  return (
    <>
      <Content />
    </>
  );
}
